import React, {
  useState,
  useEffect,
  useContext,
  useLayoutEffect,
  useMemo,
} from "react";
import { AuthContext } from "../../contexts/AuthContext";
import axios from "axios";
import Header from "../../layout/Header/Header";

import { Row, Input, Col } from "reactstrap";
import moment from "moment";
import Swal from "sweetalert2";
import {
  DashPage,
  FilterBar,
  Filtro,
  FiltroSeparador,
  BotonActualizar,
  KpiRow,
  DashCard,
  ChartBox,
  montarGraficas,
  graficaDona,
  graficaBarras,
} from "./dashboardUI";

function DashboardVentas() {
  const { user } = useContext(AuthContext);
  const URL_DASHBOARDS = process.env.REACT_APP_URL_DASHBOARDS;


  let hoy = new Date();
  let inicio = new Date();
  inicio.setDate(inicio.getDate() - 15);

  let endDate = moment(hoy).format("YYYY-MM-DD");
  let startDate = moment(inicio).format("YYYY-MM-DD");

  const [info, setInfo] = useState([]);
  const [graficasDepartamentosClientes, setGraficasDepartamentosClientes] = useState([]);
  const [graficasLineas, setGraficasLineas] = useState([]);
  const [graficasProveedores, setGraficasProveedores] = useState([]);
  const [graficasAreas, setGraficasAreas] = useState([]);
  const [graficasVendedores, setGraficasVendedores] = useState([]);
  const [graficasMes, setGraficasMes] = useState([]);
  const [graficasCodigo, setGraficasCodigo] = useState([]);
  const [graficasCodigoPiezas, setGraficasCodigoPiezas] = useState([]);

  const [valorVenta, setValorVenta] = useState(0);
  const [cantidadVenta, setCantidadVenta] = useState(0);

  const [departamentosClientes, setDepartamentosClientes] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [vendedores, setVendedores] = useState([]);
  const [lineas, setLineas] = useState([]);
  const [areas, setAreas] = useState([]);
  const [proveedores, setProveedores] = useState([]);
  const [selectedDepartamentoCliente, setSelectedDepartamentoCliente] = useState("");
  const [selectedLinea, setSelectedLinea] = useState("");
  const [selectedProveedor, setSelectedProveedor] = useState("");
  const [selectedCliente, setSelectedCliente] = useState("");
  const [selectedVendedor, setSelectedVendedor] = useState("");
  const [selectedArea, setSelectedArea] = useState("");

  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);

  const [cargando, setCargando] = useState(true);

  const Toast = Swal.mixin({
    toast: true,
    position: "center",
    showConfirmButton: false,
    // timer: 5000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
  });

  if (cargando) {
    Toast.fire({
      html: `<i class="fas fa-hourglass-half custom-spin fa-2x" style="margin-right: 16px;"></i>`, // Ícono de carga animado
      title: "Danos unos segundos....",
      customClass: {
        icon: 'animated-icon'
      }
    });
  }

useEffect(()=>{
  axios
  .get(`${URL_DASHBOARDS}Ventas/${selectedFechaInicio}/${selectedFechaFin}`, {
    headers: {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    },
  })
  .then((response) => {
    let allDisponible = response.data;
    let array = allDisponible

      setInfo(array)

      let unicosProv = allDisponible.filter(
        (value, index, self) =>
          index === self.findIndex((t) => t.idProveedor === value.idProveedor)
      );
      setProveedores(unicosProv);

      let unicosClien = allDisponible.filter(
        (value, index, self) =>
          index === self.findIndex((t) => t.idCliente === value.idCliente)
      );
      setClientes(unicosClien);

      let unicosVen = allDisponible.filter(
        (value, index, self) =>
          index === self.findIndex((t) => t.idVendedor === value.idVendedor)
      );
      setVendedores(unicosVen);

      let unicosLinea = allDisponible.filter(
        (value, index, self) =>
          index === self.findIndex((t) => t.idLinea === value.idLinea)
      );
      setLineas(unicosLinea);

      let unicosArea = allDisponible.filter(
        (value, index, self) =>
          index === self.findIndex((t) => t.idArea === value.idArea)
      );
      setAreas(unicosArea);

      let unicosDepto = allDisponible.filter(
        (value, index, self) =>
          index === self.findIndex((t) => t.idDepartamentoCliente === value.idDepartamentoCliente)
      );
      setDepartamentosClientes(unicosDepto);
      
      setCargando(false);
      Toast.close();
    })
    .catch((err) => {
      console.log(err);
    });

  
},[])

function BuscaInfo(){
  setInfo([])
  setSelectedArea("")
  setSelectedCliente("")
  setSelectedDepartamentoCliente("")
  setSelectedLinea("")
  setSelectedProveedor("")
  setSelectedVendedor("")
  setCargando(true)
  axios
  .get(`${URL_DASHBOARDS}Ventas/${selectedFechaInicio}/${selectedFechaFin}`, {
    headers: {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    },
  })
  .then((response) => {
    let allDisponible = response.data;
    let array = allDisponible

      setInfo(array)

      let unicosProv = allDisponible.filter(
        (value, index, self) =>
          index === self.findIndex((t) => t.idProveedor === value.idProveedor)
      );
      setProveedores(unicosProv);

      let unicosClien = allDisponible.filter(
        (value, index, self) =>
          index === self.findIndex((t) => t.idCliente === value.idCliente)
      );
      setClientes(unicosClien);

      let unicosVen = allDisponible.filter(
        (value, index, self) =>
          index === self.findIndex((t) => t.idVendedor === value.idVendedor)
      );
      setVendedores(unicosVen);

      let unicosLinea = allDisponible.filter(
        (value, index, self) =>
          index === self.findIndex((t) => t.idLinea === value.idLinea)
      );
      setLineas(unicosLinea);

      let unicosArea = allDisponible.filter(
        (value, index, self) =>
          index === self.findIndex((t) => t.idArea === value.idArea)
      );
      setAreas(unicosArea);

      let unicosDepto = allDisponible.filter(
        (value, index, self) =>
          index === self.findIndex((t) => t.idDepartamentoCliente === value.idDepartamentoCliente)
      );
      setDepartamentosClientes(unicosDepto);
      
      setCargando(false);
      Toast.close();
    })
    .catch((err) => {
      console.log(err);
    });
}

  useMemo(() => {
      let temp = info
          if (selectedCliente) {
            temp = temp.filter((e) =>
              e.idCliente.includes(selectedCliente)
            );
          }
          if (selectedVendedor) {
            temp = temp.filter((e) =>
              e.idVendedor.includes(selectedVendedor)
            );
          }
          if (selectedDepartamentoCliente) {
            temp = temp.filter((e) =>
              e.idDepartamentoCliente.includes(selectedDepartamentoCliente)
            );
          }

          if (selectedLinea) {
            temp = temp.filter((e) =>
              e.idLinea.includes(selectedLinea)
            );
          }

          if (selectedArea) {
            temp = temp.filter((e) =>
              e.idArea.includes(selectedArea)
            );
          }

          if (selectedProveedor) {
            temp = temp.filter((e) =>
              e.idProveedor.includes(selectedProveedor)
            );
          }

        let agrupadoDepartamentoCliente = temp.reduce(function (groups, item) {
          const val = item["idDepartamentoCliente"];
          groups[val] = groups[val] || {
            idDepartamentoCliente: item.idDepartamentoCliente,
            Importe: 0,
          };
          groups[val].Importe += item.Importe;
          groups[val].DepartamentoCliente = item.DepartamentoCliente;
          groups[val].idDepartamentoCliente = item.idDepartamentoCliente;
          return groups;
        }, []);

        let otraDepartamentoCliente = Object.values(agrupadoDepartamentoCliente).sort((a, b) =>
          a.Importe < b.Importe ? 1 : -1
        );

        setGraficasDepartamentosClientes(otraDepartamentoCliente);

        let agrupadoLinea = temp.reduce(function (groups, item) {
          const val = item["idLinea"];
          groups[val] = groups[val] || {
            idLinea: item.idLinea,
            Importe: 0,
          };
          groups[val].Importe += item.Importe;
          groups[val].Linea = item.Linea;
          groups[val].idLinea = item.idLinea;
          return groups;
        }, []);

        let otraLinea = Object.values(agrupadoLinea).sort((a, b) =>
          a.Importe < b.Importe ? 1 : -1
        );

        setGraficasLineas(otraLinea);


        let agrupadoArea = temp.reduce(function (groups, item) {
          const val = item["idArea"];
          groups[val] = groups[val] || {
            idArea: item.idArea,
            Importe: 0,
          };
          groups[val].Importe += item.Importe;
          groups[val].Area = item.Area;
          groups[val].idArea = item.idArea;
          return groups;
        }, []);

        let otraArea = Object.values(agrupadoArea).sort((a, b) =>
          a.Importe < b.Importe ? 1 : -1
        );

        setGraficasAreas(otraArea);

        let agrupadoVendedor = temp.reduce(function (groups, item) {
          const val = item["idVendedor"];
          groups[val] = groups[val] || {
            idVendedor: item.idVendedor,
            Importe: 0,
          };
          groups[val].Importe += item.Importe;
          groups[val].Vendedor = item.Vendedor;
          groups[val].idVendedor = item.idVendedor;
          return groups;
        }, []);

        let otraVendedor = Object.values(agrupadoVendedor).sort((a, b) =>
          a.Importe < b.Importe ? 1 : -1
        );

        setGraficasVendedores(otraVendedor);

        let agrupadoMes = temp.reduce(function (groups, item) {
          const val = item["Mes"];
          groups[val] = groups[val] || {
            Mes: item.Mes,
            Importe: 0,
          };
          groups[val].Importe += item.Importe;
          groups[val].Mes = item.Mes;
          return groups;
        }, []);

        let otraMes = Object.values(agrupadoMes)
        // .sort((a, b) =>
        //   a.Importe < b.Importe ? 1 : -1
        // );

        setGraficasMes(otraMes);

        let agrupadoCodigo = temp.reduce(function (groups, item) {
          const val = item["Codigo"];
          groups[val] = groups[val] || {
            Codigo: item.Codigo,
            Importe: 0,
          };
          groups[val].Importe += item.Importe;
          groups[val].Codigo = item.Codigo;
          return groups;
        }, []);

        let otraCodigo = Object.values(agrupadoCodigo)
        .sort((a, b) =>
          a.Importe < b.Importe ? 1 : -1
        )
        
        let otraCodigo2 = otraCodigo.slice(0, 10)

        setGraficasCodigo(otraCodigo2);


        let agrupadoCodigoPiezas = temp.reduce(function (groups, item) {
          const val = item["Codigo"];
          groups[val] = groups[val] || {
            Codigo: item.Codigo,
            Cantidad: 0,
          };
          groups[val].Cantidad += item.Cantidad;
          groups[val].Codigo = item.Codigo;
          return groups;
        }, []);

        let otraCodigoPiezas = Object.values(agrupadoCodigoPiezas)
        .sort((a, b) =>
          a.Cantidad < b.Cantidad ? 1 : -1
        )

        let otraCodigoPiezas2 = otraCodigoPiezas.slice(0, 10)

        setGraficasCodigoPiezas(otraCodigoPiezas2);


        let agrupadoProveedor = temp.reduce(function (groups, item) {
          const val = item["idProveedor"];
          groups[val] = groups[val] || {
            idProveedor: item.idProveedor,
            Importe: 0,
          };
          groups[val].Importe += item.Importe;
          groups[val].Proveedor = item.Proveedor;
          groups[val].idProveedor = item.idProveedor;
          return groups;
        }, []);

        let otraProveedor = Object.values(agrupadoProveedor).sort((a, b) =>
          a.Importe < b.Importe ? 1 : -1
        );

        setGraficasProveedores(otraProveedor);

        let TVal = temp.map((c) => parseFloat(c.Importe));
        let TV = TVal.reduce((t, total, index) => t + total, 0);
        setValorVenta(TV);

        let TCan = temp.map((c) => parseFloat(c.Cantidad));
        let TC = TCan.reduce((t, total, index) => t + total, 0);
        setCantidadVenta(TC);

  }, [info, selectedCliente, selectedDepartamentoCliente,  selectedLinea, selectedProveedor, selectedVendedor, selectedArea]);


  useLayoutEffect(
    () =>
      montarGraficas([
        ["chartdiv", (root) => graficaDona(root, { data: graficasDepartamentosClientes, valor: "Importe", categoria: "DepartamentoCliente", moneda: true })],
        ["chartdivLineas", (root) => graficaDona(root, { data: graficasLineas, valor: "Importe", categoria: "Linea", moneda: true })],
        ["chartdivProveedores", (root) => graficaDona(root, { data: graficasProveedores, valor: "Importe", categoria: "Proveedor", moneda: true })],
        ["chartdivVendedores", (root) => graficaDona(root, { data: graficasVendedores, valor: "Importe", categoria: "Vendedor", moneda: true })],
        ["chartdivAreas", (root) => graficaBarras(root, {
          data: graficasAreas, categoria: "Area", series: [{ valor: "Importe", nombre: "Venta" }],
          moneda: true, colorPorBarra: true, exportar: true, archivo: "Ventas_Almacenes",
        })],
        ["chartdivMes", (root) => graficaBarras(root, {
          data: graficasMes, categoria: "Mes", series: [{ valor: "Importe", nombre: "Venta", color: "#10b981" }],
          moneda: true, exportar: true, archivo: "Ventas_Mensual",
        })],
        ["chartdivCodigo", (root) => graficaBarras(root, {
          data: graficasCodigo, categoria: "Codigo", series: [{ valor: "Importe", nombre: "Venta", color: "#3b82f6" }],
          moneda: true, horizontal: true, etiquetas: true, exportar: true, archivo: "Top10_Codigos_Venta",
        })],
        ["chartdivCodigoPiezas", (root) => graficaBarras(root, {
          data: graficasCodigoPiezas, categoria: "Codigo", series: [{ valor: "Cantidad", nombre: "Piezas", color: "#8b5cf6" }],
          sufijo: " pzs", horizontal: true, etiquetas: true, exportar: true, archivo: "Top10_Codigos_Piezas",
        })],
      ]),
    [graficasDepartamentosClientes, graficasLineas, graficasAreas, graficasProveedores, graficasMes, graficasVendedores, graficasCodigo, graficasCodigoPiezas]
  );

  const kpis = [
    { label: "Venta $", value: valorVenta, formato: "moneda", icon: "fas fa-dollar-sign", color: "#10b981" },
    { label: "Piezas", value: cantidadVenta, formato: "numero", icon: "fas fa-boxes", color: "#3b82f6" },
    { label: "Líneas", value: graficasLineas.length, formato: "entero", icon: "fas fa-tags", color: "#f59e0b" },
    { label: "Vendedores", value: graficasVendedores.length, formato: "entero", icon: "fas fa-user-tie", color: "#8b5cf6" },
    { label: "Almacenes", value: graficasAreas.length, formato: "entero", icon: "fas fa-warehouse", color: "#0ea5e9" },
  ];

  const select = (label, value, onChange, opciones, idField, nameField, todos = "Todos") => (
    <Filtro label={label}>
      <Input bsSize="sm" type="select" value={value} onChange={(e) => onChange(e.target.value)}>
        <option value="">{todos}</option>
        {opciones
          .sort((a, b) => (a[nameField] > b[nameField] ? 1 : -1))
          .map((a) => {
            return <option key={a[idField]} value={a[idField]}>{a[nameField]}</option>;
          })}
      </Input>
    </Filtro>
  );

  return (
    <>
      <Header />
      {/* {user.menu_reportes ? ( */}
      <DashPage
        icon="fas fa-signal"
        color="#10b981"
        bg="#f0fdf4"
        title="Dashboard Ventas"
        subtitle="Venta en pesos y piezas por departamento, línea, proveedor, vendedor y almacén"
        cargando={cargando}
      >
        <FilterBar>
          <Filtro label="Fecha inicio" chico>
            <Input
              bsSize="sm"
              type="date"
              value={selectedFechaInicio}
              onChange={(e) => {
                setSelectedFechaInicio(e.target.value)
              }}
            />
          </Filtro>
          <Filtro label="Fecha fin" chico>
            <Input
              bsSize="sm"
              type="date"
              value={selectedFechaFin}
              onChange={(e) => {
                setSelectedFechaFin(e.target.value)
              }}
            />
          </Filtro>
          <BotonActualizar onClick={BuscaInfo} cargando={cargando} />

          <FiltroSeparador />

          {select("Departamento", selectedDepartamentoCliente, setSelectedDepartamentoCliente, departamentosClientes, "idDepartamentoCliente", "DepartamentoCliente")}
          {select("Línea", selectedLinea, setSelectedLinea, lineas, "idLinea", "Linea", "Todas")}
          {select("Proveedor", selectedProveedor, setSelectedProveedor, proveedores, "idProveedor", "Proveedor")}
          {select("Cliente", selectedCliente, setSelectedCliente, clientes, "idCliente", "Cliente")}
          {select("Vendedor", selectedVendedor, setSelectedVendedor, vendedores, "idVendedor", "Vendedor")}
          {select("Almacén", selectedArea, setSelectedArea, areas, "idArea", "Area")}
        </FilterBar>

        <KpiRow items={kpis} />

        <Row className="dash-row">
          <Col lg={7}>
            <DashCard icon="fas fa-chart-bar" color="#10b981" title="Venta mensual" subtitle="Importe vendido por mes">
              <ChartBox id="chartdivMes" height={320} cargando={cargando} vacio={graficasMes.length === 0} />
            </DashCard>
          </Col>
          <Col lg={5}>
            <DashCard icon="fas fa-warehouse" color="#0ea5e9" title="Venta por almacén" subtitle="Importe vendido">
              <ChartBox id="chartdivAreas" height={320} cargando={cargando} vacio={graficasAreas.length === 0} />
            </DashCard>
          </Col>
        </Row>

        <Row className="dash-row">
          <Col lg={6}>
            <DashCard icon="fas fa-sitemap" color="#3b82f6" title="Departamentos" subtitle="Importe y % del total">
              <ChartBox id="chartdiv" height={300} cargando={cargando} vacio={graficasDepartamentosClientes.length === 0} />
            </DashCard>
          </Col>
          <Col lg={6}>
            <DashCard icon="fas fa-tags" color="#f59e0b" title="Líneas" subtitle="Importe y % del total">
              <ChartBox id="chartdivLineas" height={300} cargando={cargando} vacio={graficasLineas.length === 0} />
            </DashCard>
          </Col>
        </Row>

        <Row className="dash-row">
          <Col lg={6}>
            <DashCard icon="fas fa-truck" color="#14b8a6" title="Proveedores" subtitle="Importe y % del total">
              <ChartBox id="chartdivProveedores" height={300} cargando={cargando} vacio={graficasProveedores.length === 0} />
            </DashCard>
          </Col>
          <Col lg={6}>
            <DashCard icon="fas fa-user-tie" color="#8b5cf6" title="Vendedores" subtitle="Importe y % del total">
              <ChartBox id="chartdivVendedores" height={300} cargando={cargando} vacio={graficasVendedores.length === 0} />
            </DashCard>
          </Col>
        </Row>

        <Row className="dash-row">
          <Col lg={6}>
            <DashCard icon="fas fa-trophy" color="#f59e0b" title="Top 10 códigos por venta $" subtitle="Los 10 códigos con mayor importe">
              <ChartBox id="chartdivCodigo" height={340} cargando={cargando} vacio={graficasCodigo.length === 0} />
            </DashCard>
          </Col>
          <Col lg={6}>
            <DashCard icon="fas fa-boxes" color="#8b5cf6" title="Top 10 códigos por piezas" subtitle="Los 10 códigos con más piezas vendidas">
              <ChartBox id="chartdivCodigoPiezas" height={340} cargando={cargando} vacio={graficasCodigoPiezas.length === 0} />
            </DashCard>
          </Col>
        </Row>
      </DashPage>
      {/* ) : undefined}  */}
    </>
  );
}
export default DashboardVentas;
